import { render, staticRenderFns } from "./DefOrigin.vue?vue&type=template&id=1dfdee5c&"
import script from "./DefOrigin.vue?vue&type=script&lang=ts&"
export * from "./DefOrigin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports